
define(
	'Code25.CaterpartsGlobal.Header'
	, [
		"Utils", "jQuery", "Tools"
	]
	, function (
		Utils, jQuery, Tools
	) {
		'use strict';
		return {
			mount: function mount(container) {

				if (!Tools.isLive()) {
					var meta = document.createElement('meta');
					meta.setAttribute("name", "robots");
					meta.setAttribute("content", "noindex");
					document.getElementsByTagName("head")[0].appendChild(meta);
				}

				var headerLogoView = require("Header.Logo.View");
				if (headerLogoView) {

					_.extend(headerLogoView.prototype, {

						initialize: _.wrap(headerLogoView.prototype.initialize, function (initialize) {
							var res = initialize.apply(this, _.rest(arguments));

							var self = this;
							$(window).on('scroll', function (e) {
								var top = $(document).scrollTop();
								if (self.lastTop == top) {
									return;
								}
								self.lastTop = top;
								if (top > 200) {
									$("#back-to-top").css("bottom", "15px");
								} else {
									$("#back-to-top").css("bottom", "-200px");
								}
							})

							return res;
						}),

						getContext: _.wrap(headerLogoView.prototype.getContext, function (getContext) {


							var res = getContext.apply(this, _.rest(arguments));

							res.isLive = Tools.isLive();
							return res;

						})
					});

				}
				var SiteSearchView = require("SiteSearch.View");

				if (SiteSearchView.SiteSearchView) {
					SiteSearchView = SiteSearchView.SiteSearchView;
				}
				SiteSearchView.prototype.toggleItemSearcher = function () {
					var element = this.$('[data-type="site-search"]');
					element.toggle();
					if (element.css('display') !== 'none') {
						$("#layout").css("paddingTop","52px");
						this.itemsSearcherComponent.cleanSearch(true);
						this.itemsSearcherComponent.setFocus();
					}else{
						$("#layout").css("paddingTop","0px");
					}
				},

					SiteSearchView.prototype.hideItemSearcher = function () {
						this.$('[data-type="site-search"]').hide();
						$("#layout").css("paddingTop","0px");
					}
			}
		};
	});
